import { render, staticRenderFns } from "./CheckboxQuestion.vue?vue&type=template&id=dd33fa8a&"
import script from "./CheckboxQuestion.vue?vue&type=script&lang=ts&"
export * from "./CheckboxQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports